var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 163,
    viewBox: "0 0 648 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.426 82.1239C207.426 55.1329 226.588 35.3276 253.688 35.3276C280.789 35.3276 299.937 55.0782 299.937 82.1239C300.175 94.1137 295.861 105.748 287.865 114.686L295.325 123.09L284.375 132.315L276.477 123.445C269.446 127.114 261.619 128.994 253.688 128.92C226.56 128.865 207.426 109.06 207.426 82.1239ZM266.431 112.099L255.18 99.356L266.294 90.1309L277.559 102.887C281.686 96.7612 283.818 89.5089 283.663 82.1239C283.663 63.4136 271.865 49.4391 253.688 49.4391C235.512 49.4391 223.713 63.3589 223.713 82.1239C223.713 100.889 235.375 114.822 253.688 114.822C258.089 114.852 262.442 113.903 266.431 112.044V112.099Z",
    fill: "#0A8B98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.081 127.291L339.139 93.4704H323.276V127.291H307.398V36.7646H347.091C364.994 36.7646 376.806 48.2892 376.806 65.1107C376.806 81.1246 366.226 89.9391 355.235 91.7048L377.477 127.291H359.081ZM360.573 65.0286C360.573 56.3509 354.072 50.794 345.12 50.794H323.221V79.5369H345.12C354.072 79.4959 360.573 73.802 360.573 64.9738V65.0286Z",
    fill: "#0A8B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412.258 127.291V36.7646H452.142C471.14 36.7646 481.583 49.6579 481.583 65.1107C481.583 80.5635 471.003 93.3336 452.142 93.3336H428.135V127.291H412.258ZM465.364 65.1107C465.364 56.433 458.999 50.7392 450.034 50.7392H428.135V79.3864H449.966C458.931 79.3864 465.364 73.6651 465.364 65.1107Z",
    fill: "#0A8B98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M550.616 127.291L543.964 109.799H502.465L495.813 127.291H477.773L513.36 36.8193H533.165L568.752 127.291H550.616ZM523.242 52.6964L506.941 95.8109H539.489L523.242 52.6964Z",
    fill: "#0A8B98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M596.471 127.291V89.6654L561.336 36.7646H579.512L604.341 75.4308L629.156 36.7646H647.401L612.334 89.6654V127.291H596.471Z",
    fill: "#0A8B98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163 0H0V163H163V0Z",
    fill: "#0A8B98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0034 51.9971H38.6797V108.744H61.0034V51.9971Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.804 51.9971H97.4805V108.744H119.804V51.9971Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4805 51.9839V29.6602L61.018 29.6602V51.9839H97.4805Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 131.067V108.743H61.0375V131.067H97.5Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M129.947 142.238V119.914H107.624V142.238H129.947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0210ce05b7370971b00805cf2e9241ec.svg";
export { ForwardRef as ReactComponent };